import React from 'react';
import Card from '@material-ui/core/Card';
import QueryString from 'query-string';
import Button from '@material-ui/core/Button';
import { SPACES } from 'common/constants/sizes';
import { getTeamAvatar } from 'views/root/views/home/views/people/views/teams/teams.service';
import { Flex } from 'components/base/layout-components';
import Text from '../base/Text';

export const createTeamIdFilterConfig = (
  type = 'multi-autocomplete',
  teams,
  history,
  location
) => ({
  type,
  reqKey: 'team_ids',
  options: teams,
  getAvatar: getTeamAvatar,
  autoCompleteProps: {
    PaperComponent: ({ children }) => {
      if (teams.length === 0) {
        return (
          <Card>
            <Flex
              width='100%'
              direction='column'
              items='center'
              content='center'
              justify='center'
              onMouseDown={e => {
                const search = QueryString.parse(location.search, {
                  ignoreQueryPrefix: true
                });

                history.push({
                  pathname: '/contributors/teams',
                  search: `?${QueryString.stringify(search)}`
                });
              }}
            >
              <Flex padding='medium' direction='column' justify='center'>
                <Text size='x-x-large' pb={SPACES.medium}>
                  No teams found.
                </Text>
                <Button variant='contained'>Add Team</Button>
              </Flex>
            </Flex>
          </Card>
        );
      }

      return <Card>{children}</Card>;
    }
  }
});
